import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import styles from '../styles/uitk-egds-list.css';

const EGDSListOrientationMap = [
    ['inline', 'orientation-inline'],
    ['stacked', 'orientation-stacked'],
];
const EGDSListOrientations = new Map(EGDSListOrientationMap);
const EGDSListSizeMap = [
    [1, 'size-1'],
    [2, 'size-2'],
    [3, 'size-3'],
];
const EGDSListSizes = new Map(EGDSListSizeMap);
const EGDSListTypeMap = [
    ['unordered', 'ul'],
    ['ordered', 'ol'],
];
const EGDSListTypes = new Map(EGDSListTypeMap);
const EGDSListBulletMap = [
    ['default', 'bullet-default'],
    ['no-bullet', 'bullet-none'],
    ['icon-alternate', 'bullet-icon-alternate'],
    ['icon-standard', 'bullet-icon-standard'],
    ['tiered-numbered', 'bullet-tiered-numbered'],
];
const EGDSListBullets = new Map(EGDSListBulletMap);
const EGDSListItemThemeMap = [
    ['default', 'default-theme'],
    ['emphasis', 'emphasis-theme'],
    ['positive', 'positive-theme'],
    ['negative', 'negative-theme'],
];
const EGDSListItemThemes = new Map(EGDSListItemThemeMap);

const getClassNameList$1 = classNames.bind(styles);
const EGDSListContext = React.createContext({});
const EGDSList = (props) => {
    const { bullet, children, className, data, orientation, size, type, spacing, indent, ...attributes } = props;
    const baseClass = 'uitk-typelist'; // Temporary: name clash with menu
    const cssClassNames = getClassNameList$1(baseClass, orientation && `${baseClass}-${EGDSListOrientations.get(orientation)}`, size && `${baseClass}-${EGDSListSizes.get(size)}`, spacing && `${baseClass}-spacing`, className);
    // Renders the custom Tag
    const Tag = (type && EGDSListTypes.get(type)) || 'ul';
    // Renders children if data is used
    const dataGuard = (dataType) => dataType[0].content !== undefined;
    const newChildren = [];
    const EGDSListContextValue = React.useMemo(() => ({ bullet, orientation, type, size, indent }), [
        bullet,
        orientation,
        type,
        size,
        indent,
    ]);
    data?.forEach((item, index) => {
        newChildren.push(jsx(EGDSListItem, { children: dataGuard(data) ? [item && item?.icon, item?.content] : item }, `listitem-${index}`));
    });
    return (jsx(Tag, { className: cssClassNames, ...attributes, children: jsx(EGDSListContext.Provider, { value: EGDSListContextValue, children: (!data && children) || newChildren || null }) }));
};
EGDSList.displayName = 'EGDSList';
EGDSList.defaultProps = {
    bullet: 'default',
    orientation: 'stacked',
    size: 2,
    type: 'unordered',
    spacing: true,
    indent: true,
};

const getClassNameList = classNames.bind(styles);
const EGDSListItem = (props) => {
    const { children, theme = 'default', ...attributes } = props;
    const context = React.useContext(EGDSListContext);
    const { bullet, orientation, size, type, indent } = context;
    const bulletClass = () => {
        // If bullet is default, set type as bullet style
        // if bullet is not default, set bullet as bullet style
        let value;
        if (bullet && type) {
            value = EGDSListBullets.get(bullet) === 'bullet-default' ? `bullet-${type}` : EGDSListBullets.get(bullet);
        }
        return value;
    };
    const baseClass = 'uitk-typelist-item'; // Temporary: name clash with menu
    const bulletBaseClass = `${baseClass}-bulletchar`;
    const wrapperClassNames = getClassNameList(baseClass, `${baseClass}-${bulletClass()}`, bullet && bullet.includes('icon') && `${baseClass}-bullet-icon`, orientation && `${baseClass}-${EGDSListOrientations.get(orientation)}`, size && `${baseClass}-${EGDSListSizes.get(size)}`, bullet && !bullet.includes('icon') && `${baseClass}-${EGDSListItemThemes.get(theme)}`, bullet && bullet.includes('icon') && theme && `${baseClass}-bullet-icon-${EGDSListItemThemes.get(theme)}`, indent ? `${baseClass}-indent` : `${baseClass}-no-indent`);
    const bulletCssClassNames = getClassNameList(bulletBaseClass, `${bulletBaseClass}-${bulletClass()}`, size && `${bulletBaseClass}-${EGDSListSizes.get(size)}`);
    const displayChildren = React.Children.toArray(children).map((child, index) => child?.type?.displayName?.match(/(EGDS|Uitk)Icon/) ? (jsx("div", { className: getClassNameList(`${baseClass}-icon`), children: child }, `list-item-${index}`)) : (child));
    // Set bullet markup?
    const bulletMarkup = bullet &&
        (EGDSListBullets.get(bullet) === 'bullet-default' || EGDSListBullets.get(bullet) === 'bullet-tiered-numbered') ? (jsx("span", { "aria-hidden": "true", className: bulletCssClassNames })) : null;
    // Wrap children to make grid layout to work as expected with bullet markup
    const wrappedChildren = bulletMarkup ? (jsx("span", { className: getClassNameList(`${baseClass}-child`), children: displayChildren })) : (displayChildren);
    return displayChildren ? (jsxs("li", { className: wrapperClassNames, ...attributes, children: [bulletMarkup, wrappedChildren] })) : null;
};
EGDSListItem.displayName = 'EGDSListItem';

export { EGDSList as E, EGDSListItem as a };
//# sourceMappingURL=index-chunk.esm.js.map
